import { useStore } from 'zustand';
import { createStore } from 'zustand/vanilla';
import { useAppStoreApi } from './appStore';

const identity = (state) => state;

// A feature store follows the lifetime of the main tab that owns it.
export default function createTabStore(initializer) {
    const stores = new WeakMap();

    function useTabStoreApi() {
        const owner = useAppStoreApi();
        if (!stores.has(owner)) stores.set(owner, createStore(initializer));
        return stores.get(owner);
    }

    function useTabStore(selector = identity) {
        return useStore(useTabStoreApi(), selector);
    }

    return [useTabStore, useTabStoreApi];
}
